import React, { useEffect, useState } from 'react'
import { siteUrl } from '../../../shared/utils/siteUrl'
import { description, title } from '../../../constants/activity-seo'
import previewImg from '../../../assets/images/preview.png'
import Seo from '../../../shared/seo'
const seo_props = {
  title: title,
  description: description,
  image: siteUrl + previewImg,
}
var SEO_RENDERED = false
/**
 *  THE IDEA IS TO RENDER SEO JUST ONCE TO AVOID RE-SRC THE OATS AND PREVENT RENDERING ERRORS
 * @returns
 */
export default function AppSeo() {
  const [ready, setReady] = useState(false)
  const wait = typeof window !== 'undefined'
  useEffect(() => {
    const timeout = setTimeout(() => {
      setReady(true)
    }, 3000)
    return () => {
      clearTimeout(timeout)
    }
  }, [])

  //if (!SEO_RENDERED && (!wait || (wait && ready))) {
  if (!SEO_RENDERED) {
    SEO_RENDERED = true
    return <Seo {...seo_props} />
  }
  return null
}
